import {Component, OnInit} from "@angular/core";
import {DialogService} from "../bootstrap-modal/dialog.service";
import {DialogComponent} from "../bootstrap-modal/dialog.component";
import {AccountingService} from "./accounting.service";
import {handleErrors} from "../misc/handle-errors.decorator";
import {exposeComponentInDebugMode} from "../misc/expose-component-in-debug-mode.decorator";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import * as moment from "moment";

export interface CreateExpenseDialogInputModel {
  projectId: string;
}

@Component({
  templateUrl: "./create-expense-dialog.template.pug",
  providers: [
    AccountingService,
  ],
})
@exposeComponentInDebugMode()
/** @deprecated */
export class CreateExpenseDialogComponent extends DialogComponent<CreateExpenseDialogInputModel, boolean>
  implements CreateExpenseDialogInputModel, OnInit {
  error: Error;
  loading: boolean = false;
  projectId: string;

  accountId: string;
  currency: string;

  expenseForm = new FormGroup({
    expenseDate: new FormControl("", Validators.required),
    period: new FormControl({value: "", disabled: true}),
    usdAmount: new FormControl("", Validators.required),
    localAmount: new FormControl("", Validators.required),
    bucket: new FormControl("", Validators.required),
  });

  static showCreateExpenseDialogModal(dialogService: DialogService, projectId: string): Promise<boolean> {
    return dialogService.showDialog(CreateExpenseDialogComponent, {projectId});
  }

  getPeriod(date: string): string {
    const month = 1 + moment(date, "YYYY/MM/DD").month();
    let year = moment(date, "YYYY/MM/DD").year();
    let quarter = 1;

    switch (month) {
      case 2:
      case 3:
      case 4:
        quarter = 2;
        break;
      case 5:
      case 6:
      case 7:
        quarter = 3;
        break;
      case 8:
      case 9:
      case 10:
        quarter = 4;
        break;
      case 11:
      case 12:
        year += 1;
        break;
      default:
        break;
    }

    return `Q${quarter}/${year}`;
  }

  constructor(
    public dialogService: DialogService,
    private accountingService: AccountingService,
  ) {
    super(dialogService);

    this.result = false;
  }

  cancel(): void {
    this.close();
    this.result = false;
  }

  @handleErrors()
  async submit() {
    const expense = this.expenseForm.getRawValue();
    expense.expenseDate = moment(expense.expenseDate).toDate();
    expense.accountId = this.accountId;
    expense.sourceDB = "TMC";
    expense.currency = this.currency;

    await this.accountingService.createExpense(expense);

    this.close();
  }

  ngOnInit(): void {
  }

  public expenseDateChange($event): void {
    if ($event.type === "dateChanged") {
      this.expenseForm.patchValue({
        expenseDate: $event.data,
        period: this.getPeriod($event.data),
      });
    }
  }
}
